import { toApiFrequency } from "./frequency";
import { toApiPhone } from "./phone";
import { ScheduleFormValues } from "../schema/schedule-form-schema";
import { CreateNotificationSchedulePayload } from "../types";

/**
 * Converte os valores do form no payload aceito pela API.
 *
 * `recipients` carrega apenas o telefone, e só quando o canal WhatsApp está
 * ativo: o e-mail do destinatário é extraído do usuário logado pelo backend,
 * então não é enviado daqui.
 *
 * Extraído da sheet para ser reusado pelo fluxo do chat da Lia (ver
 * `../chat/schedule-form-slot.tsx`) — os dois caminhos escrevem o mesmo payload.
 */
export function toPayload(
  values: ScheduleFormValues,
): CreateNotificationSchedulePayload {
  // A API espera dígitos com DDI, ex.: 5519999999999.
  const phone = values.phone ? toApiPhone(values.phone) : "";

  return {
    tool_key: values.toolKey,
    ...toApiFrequency(values.frequency, values.weekdays, values.time),
    send_time: values.time,
    timezone: values.timezone,
    channels: values.channels,
    recipients: values.channels.includes("whatsapp") && phone ? [phone] : [],
  };
}
